module.exports = __webpack_public_path__ + "static/img/8.6c2996e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/eng/8.png
// module id = ygDF
// module chunks = 0